import { ApproverMessage } from '../../../../../types/ApproverMessage';
import { OfferApprovalSettingsMessage } from '../../../../../types/OfferApprovalSettingsMessage';
import { Checkbox } from '../../../../cdl/Checkbox/Checkbox';
import { Label } from '../../../../cdl/Label/Label';
import { Radio, RadioGroupItem } from '../../../../cdl/RadioGroup/RadioGroup';
import { ApproverLabel } from '../../../../offer/MultipleApprovers/components/ApproverLabel';
import { ApproverListWrapper } from '../../../../offer/MultipleApprovers/components/ApproverListWrapper';

interface ApproverListProps {
    approvers: ApproverMessage[];
    preventMultipleApprovers: OfferApprovalSettingsMessage['preventMultipleApprovers'];
    onApproverChange: (approver: ApproverMessage) => void;
    selectedApproverEmails: string[];
}

export const ApproverList = ({
    approvers,
    preventMultipleApprovers,
    onApproverChange,
    selectedApproverEmails,
}: ApproverListProps) => {
    const isApproverSelected = (approver: ApproverMessage): boolean => {
        return selectedApproverEmails.includes(approver.emailAddress);
    };

    const handleApproverChange = (approver: ApproverMessage) => () => {
        onApproverChange(approver);
    };

    if (preventMultipleApprovers) {
        return (
            <ApproverListWrapper>
                {approvers.map((approver) => (
                    <RadioGroupItem key={approver.emailAddress}>
                        <Radio value={approver.emailAddress} />
                        <Label>
                            <ApproverLabel approver={approver} />
                        </Label>
                    </RadioGroupItem>
                ))}
            </ApproverListWrapper>
        );
    }

    return (
        <ApproverListWrapper>
            {approvers.map((approver) => (
                <Checkbox
                    key={approver.emailAddress}
                    checked={isApproverSelected(approver)}
                    onChange={handleApproverChange(approver)}
                    label={<ApproverLabel approver={approver} />}
                />
            ))}
        </ApproverListWrapper>
    );
};
